export default __webpack_public_path__ + "static/media/intro5.db32f212.mp3";